import {_} from 'lodash';
import * as ko from "knockout";
import {MutableCompany} from "../MutableCompany";
import {MutableCompanySyncStep} from "../synccycle/MutableCompanySyncStep";
import {TRUMode, TTabValue} from ".";
import {global, lm} from "../../../../appContext";
import {nsTooltip} from "../../../../util/nsTooltip";
import {IComboboxV2Options} from "../../../combobox/v2";
import {createServiceListPromise} from "../../../combobox/v2-sources";
import {ICompanySyncstep, IMessageData, ISyncstep, ISystem} from "../../../../index";
import {getSearchParamsFn} from "../../../../util/request";
import {StatusManager} from "../StatusManager";
import {nsUtils} from "../nsUtils";
import {IParams as IEllipsisDropdownParams} from "../../../button/ellipsis-dropdown";
import {DELETING_MESSAGE, PLEASE_WAIT_MESSAGE, UPDATING_MESSAGE} from "../../../../constants/Language";
import {createErrorMessage} from "../../../../util/misc";
import {Permission} from "../../../../constants/Permission";
import {setRouteHash} from "../../../../constants/RouteDefinitions";
import {IDropdownButton} from "../../../button";
import {SNACKBAR_DURATION_LONG} from "../../../../constants";
import {nsFile} from "../nsFile";
import {nsDom} from "../../../../util/dom";
import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";
import {TBtnHeader} from "..";
import {nsSync} from "../../../../util/nsSync";

export class MutableSyncCycle {

    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker()
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null)
    private readonly isReady: KnockoutObservable<boolean> = ko.observable(true)
    private readonly _mutableCompanySyncsteps: KnockoutObservableArray<MutableCompanySyncStep> = ko.observableArray()
    public readonly draggingSource: KnockoutObservable<MutableCompanySyncStep | null> = ko.observable(null);
    public readonly draggingTarget: KnockoutObservable<MutableCompanySyncStep | null> = ko.observable(null);
    public readonly draggingTargetElement: KnockoutObservable<HTMLElement | null> = ko.observable(null);
    public readonly crudMode: KnockoutObservable<TRUMode> = ko.observable<TRUMode>('read');
    private readonly buttons: TBtnHeader[]
    private readonly actionButtons: TBtnHeader[]
    private readonly moreOptionsDropdown: IEllipsisDropdownParams
    private readonly mutableCompany: MutableCompany
    private readonly syncstepPickerInput = ko.observable('')

    constructor(private statusManager: StatusManager) {
        this.kosub.subscribe(this.statusManager.isSyncUpdated, bool => {
            if (bool) {
                this.init()
            }
        })
        this.mutableCompany = statusManager.mutableCompany
        this.buttons = [this.btnCancel, this.btnSubmit]
        this.actionButtons = [this.btnExecuteDeltaSync, this.btnFullSync]
        this.moreOptionsDropdown = {
            buttons: [
                this.btnExecuteSyncstep,
                this.btnScheduleSyncsteps,
                this.btnAddNextSyncStep,
                this.btnDeleteLastSyncStep,
                this.btnDownloadHrFile,
                this.btnDownloadHiFile,
                this.btnDownloadLogFile,
                this.btnEdit,
                this.btnDeleteLastSyncCycle,
            ],
            icon: 'fas fa-chevron-down',
            btnClass: 'btn btn-action btn-sync-actions-toggle',
            label: 'pageshell.actions.more',
            title: 'pageshell.actions.more',
        }
    }

    public init() {
        this.isReady(false)
        const mcssConfigs: Record<ICompanySyncstep['id'], { isExpanded: boolean, tabValue: TTabValue | null }> = {}
        this._mutableCompanySyncsteps().forEach(o => {
            mcssConfigs[o.companySyncstep.id] = {
                isExpanded: nsUtils.getAnyValue(o.isExpanded),
                tabValue: nsUtils.getAnyValue(o.tabValue),
            }
            o.dispose()
        })
        this._mutableCompanySyncsteps.removeAll()
        const syncsteps_company = _.sortBy(this.statusManager.company.syncsteps, 'order')
        const syncsteps_importfile = this.statusManager.importfile.synccyclesteps
        const mutableCompanySyncsteps = syncsteps_company.map((css: ICompanySyncstep, index: number) => {
            const ifss = syncsteps_importfile.find(o => o.syncstepname == css.syncstep.name)
            const ret = new MutableCompanySyncStep(css, ifss ?? null, this, this.statusManager, index)
            const mcssConfig = mcssConfigs[css.id];
            if (mcssConfig) {
                ret.isExpanded(mcssConfig.isExpanded)
                if (mcssConfig.tabValue !== null) {
                    ret.tabValue(mcssConfig.tabValue)
                }
            }
            return ret
        })
        this._mutableCompanySyncsteps(mutableCompanySyncsteps)
        this.isReady(true)
    }

    public mutableCompanySyncsteps = ko.pureComputed(() => {
        return _.sortBy(this._mutableCompanySyncsteps(), (o: MutableCompanySyncStep) => o.index())
    })

    public swap() {
        const src = this.draggingSource();
        const trg = this.draggingTarget();
        if (!src || !trg) {
            return
        }
        const srcIndex = src.index()
        const trgIndex = trg.index()
        src.index(trgIndex)
        trg.index(srcIndex)
    }

    public isCrudMode(...crudMode: TRUMode[]): boolean {
        return crudMode.includes(this.crudMode())
    }

    public btnPauseDeltaSync: TBtnHeader = {
        onClick: () => {
            const oldBool = this.mutableCompany.props.pausedeltasync!();
            const newBool = !oldBool
            global.dialogManager.addConfirm({
                title: `synccycle.dialog.pausedeltasync.${newBool}`,
                content: lm.t(`synccycle.dialog.pausedeltasync.body.${newBool}`) ?? '',
                buttons: {
                    cancel: {
                        label: 'synccycle.dialog.pausedeltasync.btn.cancel',
                    },
                    confirm: {
                        label: 'synccycle.dialog.pausedeltasync.btn.confirm',
                        onClick: () => {
                            this.messageData({message: UPDATING_MESSAGE})
                            this.statusManager.isSubmitting(true)
                            this.mutableCompany.props.pausedeltasync!(!oldBool)
                            Promise.resolve()
                                .then(() => this.mutableCompany.submit(['pausedeltasync'])
                                    .then((data) => {
                                        global.snackbarData({message: `synccycle.dialog.pausedeltasync.message.${newBool}`})
                                        this.messageData(null)
                                        this.init()
                                        this.statusManager.isSubmitting(false)
                                    })
                                )
                                .catch((reason: string) => {
                                    this.mutableCompany.props.pausedeltasync!(oldBool)
                                    this.statusManager.isSubmitting(false)
                                    this.messageData(createErrorMessage(String(reason)))
                                })
                        }
                    },
                },
            })
        },
        icon: () => this.mutableCompany.props.pausedeltasync!() ? 'far fa-toggle-off': 'far fa-toggle-on',
        label: () => `synccycle.btn.pausedeltasync.${this.mutableCompany.props.pausedeltasync!()}`,
        cls: () => {
            if (this.statusManager.permission() < Permission.CompanyAdmin) {
                return 'btn-pausedeltasync-non-interactive'
            }
        },
        enabled: () => this.statusManager.permission() >= Permission.CompanyAdmin,
        validator: () => {
            const a = this.isCrudMode('read');
            const b = !this.isCrudMode('update');
            const c = !this.isAnySyncstepCreateOrUpdate()
            const d = this.statusManager.company.deltasync
            return a && b && c && d
        },
    }

    private btnEdit: TBtnHeader = {
        onClick: () => {
            this.messageData(null)
            const pauseDeltaSync = this.mutableCompany.props.pausedeltasync!()
            const isDeltaSyncSupported = this.statusManager.company.deltasync;
            if (!isDeltaSyncSupported || pauseDeltaSync) {
                this.crudMode('update')
                return
            }
            global.dialogManager.addConfirm({
                title: 'synccycle.dialog.editsynccycle.deltasyncpaused',
                content: lm.t('synccycle.dialog.editsynccycle.deltasyncpaused.body') ?? '',
                buttons: {
                    confirm: {
                        label: 'synccycle.dialog.editsynccycle.deltasyncpaused.btn.confirm',
                        onClick: () => {
                            this.statusManager.notifyAboutPauseDeltaSync(true)
                            this.messageData({message: UPDATING_MESSAGE})
                            this.statusManager.isSubmitting(true)
                            this.mutableCompany.props.pausedeltasync!(!pauseDeltaSync)
                            Promise.resolve()
                                .then(() => this.mutableCompany.submit(['pausedeltasync']))
                                .then((data) => {
                                    global.snackbarData({message: `synccycle.dialog.pausedeltasync.message.${!pauseDeltaSync}`})
                                    this.messageData(null)
                                    this.init()
                                    this.statusManager.isSubmitting(false)
                                    this.crudMode('update')
                                })
                                .catch((reason: string) => {
                                    this.mutableCompany.props.pausedeltasync!(pauseDeltaSync)
                                    this.statusManager.isSubmitting(false)
                                    this.messageData(createErrorMessage(String(reason)))
                                })
                        }
                    },
                    cancel: {
                        label: 'synccycle.dialog.rundeltasync.btn.cancel',
                    }
                },
            })
        },
        enabled: () => {
            const a = ['executed', 'executedwitherrors'].includes(this.statusManager.getSyncCycleStatus())
            const b = !this.statusManager.hasImportfile
            return a || b
        },
        icon: 'fa-pencil',
        label: 'synccycle.btn.edit',
        cls: 'btn-separated btn-action',
        description: () => {
            return lm.t('synccycle.btn.edit.tooltip.' + this.statusManager.getSyncCycleStatus(), undefined, true)
        },
        validator: () => {
            const a = this.isCrudMode('read')
            const b = !this.isAnySyncstepCreateOrUpdate()
            const c = this.statusManager.permission() >= Permission.OrganizationAdmin
            return a && b && c
        },
    }

    private btnExecuteDeltaSync: TBtnHeader = {
        onClick: () => {
            global.dialogManager.addConfirm({
                title: 'synccycle.dialog.rundeltasync',
                content: lm.t('synccycle.dialog.rundeltasync.body') ?? '',
                buttons: {
                    confirm: {
                        label: 'synccycle.dialog.rundeltasync.btn.confirm',
                        onClick: () => {
                            this.statusManager.isSubmitting(true)
                            this.messageData({message: PLEASE_WAIT_MESSAGE});
                            this.mutableCompany.props.syncableedits!(true)
                            this.mutableCompany.submit(['syncableedits'])
                                .then((data) => {
                                    global.snackbarData({message: 'synccycle.dialog.rundeltasync.message.success'})
                                    this.messageData(null)
                                    this.init()
                                    this.statusManager.isSubmitting(false)
                                })
                                .catch((reason: string) => {
                                    this.statusManager.isSubmitting(false)
                                    this.messageData(createErrorMessage(String(reason)))
                                })
                        }
                    },
                    cancel: {
                        label: 'synccycle.dialog.rundeltasync.btn.cancel',
                    }
                },
            })
        },
        icon: 'fa-bolt',
        label: 'synccycle.btn.rundeltasync',
        validator: () => {
            const a = this.isCrudMode('read');
            const b = !this.isAnySyncstepCreateOrUpdate();
            const c = this.statusManager.company.deltasync
            const d = this.statusManager.permission() >= Permission.CompanyAdmin
            return a && b && c && d
        },
        cls: 'btn-action',
        enabled: () => this.isAddToQueButtonsAvailable(),
    }

    private btnCancel: TBtnHeader = {
        label: 'synccycle.btn.cancel',
        cls: 'btn-action',
        onClick: () => {
            Promise.resolve()
                .then(() => this.init())
                .then(() => {
                    this.crudMode('read')
                    this.notifyAboutPauseDeltaSync()
                })
        },
        icon: 'fa-ban',
        validator: () => this.isCrudMode('update'),
    }

    private btnSubmit: TBtnHeader = {
        cls: 'btn-success btn-action',
        label: 'synccycle.btn.submit',
        enabled: ko.pureComputed(() => {
            const isValid = this.mutableCompanySyncsteps().reduce((ret: boolean, mcss: MutableCompanySyncStep) => {
                switch (mcss.crudMode()) {
                    case 'create':
                    case 'update':
                        return mcss.isSyncstepValid() && ret
                    default:
                        return ret;
                }
            }, true)
            const isChanged = this.mutableCompanySyncsteps().reduce((ret: boolean, mcss: MutableCompanySyncStep) => {
                switch (mcss.crudMode()) {
                    case 'create':
                    case 'delete':
                        return true
                    case 'update':
                        return mcss.isChanged() || ret
                    default:
                        return ret
                }
            }, false)
            return isValid && isChanged
        }),
        onClick: () => this.submit(),
        icon: 'fa-save',
        validator: () => this.isCrudMode('update'),
    }

    private btnDeleteLastSyncCycle: TBtnHeader = {
        label: 'synccycle.btn.deletelastsynccycle',
        cls: 'btn-separated btn-destructive explicit',
        onClick: () => {
            global.dialogManager.addConfirm({
                title: `synccycle.dialog.deletelastsynccycle`,
                content: lm.t(`synccycle.dialog.deletelastsynccycle.body`) ?? '',
                buttons: {
                    cancel: {
                        label: `synccycle.dialog.deletelastsynccycle.btn.cancel`,
                    },
                    confirm: {
                        label: `synccycle.dialog.deletelastsynccycle.btn.confirm`,
                        onClick: () => {
                            return Promise
                                .resolve()
                                .then(() => {
                                    this.statusManager.isSubmitting(true)
                                    this.messageData({message: DELETING_MESSAGE});
                                })
                                .then(() => this.statusManager.do_deletelastsynccycle())
                                .then(() => {
                                    global.snackbarData({message: `synccycle.dialog.deletelastsynccycle.message.success`})
                                    this.messageData(null)
                                    this.statusManager.init()
                                    this.statusManager.isSubmitting(false)
                                })
                                .catch((reason: string) => {
                                    global.snackbarData(createErrorMessage(String(reason)))
                                })
                        },
                        cls: 'btn-danger',
                    }
                }
            })
        },
        enabled: () => !this.isAnySyncstepCreateOrUpdate(),
        icon: 'fa-trash-alt',
        validator: () => {
            const a = this.isCrudMode('read')
            const b = this.statusManager.permission() >= Permission.SuperAdmin
            const c = this.statusManager.hasImportfile
            return a && b && c
        },
    }

    private btnFullSync: TBtnHeader = {
        label: 'synccycle.btn.fullsync',
        enabled: () => {
            const a = this.isAddToQueButtonsAvailable()
            const b = !this.isAnySyncstepCreateOrUpdate()
            return a && b
        },
        onClick: () => {
            global.dialogManager.addConfirm({
                buttons: {
                    confirm: {
                        label: 'synccycle.dialog.fullsync.btn.confirm',
                        onClick: () => {
                            this.statusManager.isSubmitting(true)
                            this.messageData({message: PLEASE_WAIT_MESSAGE});
                            this.mutableCompany.props.forcefullsync!(true)
                            this.mutableCompany.submit(['forcefullsync'])
                                .then((data) => {
                                    global.snackbarData({message: `synccycle.dialog.fullsync.message.success`})
                                    this.messageData(null)
                                    this.init()
                                    this.statusManager.isSubmitting(false)
                                })
                                .catch((reason: string) => {
                                    this.statusManager.isSubmitting(false)
                                    this.messageData(createErrorMessage(String(reason)))
                                })
                        }
                    }
                },
                content: lm.t(`synccycle.dialog.fullsync.body`) ?? '',
                fullWidth: false,
                title: `synccycle.dialog.fullsync`,
            })
        },
        icon: 'fa-sync',
        cls: 'btn-action',
        validator: () => {
            const a = this.isCrudMode('read');
            const b = this.statusManager.permission() >= Permission.CompanyAdmin
            const c = this.statusManager.company.cloudschedule
            return a && b && c
        },
    }

    private btnExecuteSyncstep: IDropdownButton = {
        cls: 'btn-action',
        icon: 'fa-play',
        label: () => ({
            k: 'synccycle.btn.executesyncstep',
            obj: {
                companysyncstep: this.statusManager.getNextCompanySyncstepForExecution(),
            },
        }),
        enabled: () => {
            const a = this.statusManager.canNextCompanySyncstepBeExecuted()
            const b = this.isCrudMode('read')
            return a && b
        },
        validator: () => this.statusManager.permission() >= Permission.CompanyAdmin,
        onClick: () => {
            const next = this.statusManager.getNextCompanySyncstepForExecution();
            if (next) {
                setRouteHash('executesyncstep', {id: next.id});
            }
        },
    };

    private btnScheduleSyncsteps: IDropdownButton = {
        cls: 'btn-action',
        icon: 'fa-forward',
        label: 'synccycle.btn.executeremainingsyncsteps',
        enabled: () => {
            const a = this.statusManager.canNextCompanySyncstepBeExecuted()
            const b = this.isCrudMode('read')
            return a && b
        },
        validator: () => this.statusManager.permission() >= Permission.CompanyAdmin,
        onClick: () => global.dialogManager.addConfirm({
            title: `synccycle.dialog.executeremainingsyncsteps`,
            content: lm.t(`synccycle.dialog.executeremainingsyncsteps.body`) ?? '',
            buttons: {
                cancel: {
                    label: 'synccycle.dialog.executeremainingsyncsteps.btn.cancel',
                },
                confirm: {
                    label: 'synccycle.dialog.executeremainingsyncsteps.btn.confirm',
                    onClick: () => {
                        const next = this.statusManager.getNextCompanySyncstepForExecution();
                        if (!next) {
                            return;
                        }
                        this.messageData({message: PLEASE_WAIT_MESSAGE})
                        this.statusManager.isSubmitting(true)
                        this.statusManager
                            .do_schedulesync(next.id)
                            .then(() => global.snackbarData({
                                message: `schedulesyncsteps.success.description`,
                                duration: SNACKBAR_DURATION_LONG
                            }))
                            .then(() => this.statusManager.init())
                            .catch((reason: string) => {
                                this.statusManager.isSubmitting(false)
                                this.messageData(createErrorMessage(String(reason)))
                            })
                    }
                },
            },
        }),
    }

    private btnDownloadHrFile: TBtnHeader = {
        cls: 'btn-separated btn-action',
        label: 'synccycle.btn.downloadhrfile',
        icon: 'fa-download',
        onClick: () => {
            const filepath = this.statusManager.importfile.pathhrfile;
            const filename = filepath.slice(filepath.lastIndexOf('\\') + 1);
            nsFile
                .downloadFile({
                    filename: filename,
                    params: {id: this.statusManager.importfile.id},
                    servicename: 'getimportfile',
                })
                .catch((reason: string) => this.messageData(createErrorMessage(String(reason))))
        },
        validator: () => !!this.statusManager.importfile?.pathhrfile,
    }

    private btnDownloadHiFile: TBtnHeader = {
        cls: 'btn-action',
        label: 'synccycle.btn.downloadorgfile',
        icon: 'fa-download',
        onClick: () => {
            const filepath = this.statusManager.importfile.pathhifile;
            const filename = filepath.slice(filepath.lastIndexOf('\\') + 1);
            nsFile
                .downloadFile({
                    filename: filename,
                    params: {id: this.statusManager.importfile.id},
                    servicename: 'getimportorgfile',
                })
                .catch((reason: string) => this.messageData(createErrorMessage(String(reason))))
        },
        validator: () => !!this.statusManager.importfile?.pathhifile,
    }

    private btnDownloadLogFile: TBtnHeader = {
        cls: 'btn-action',
        label: 'synccycle.btn.downloadclientlog',
        icon: 'fa-download',
        onClick: () => {
            const filepath = this.statusManager.importfile.pathlogfile
            const filename = filepath.slice(filepath.lastIndexOf('\\') + 1);
            nsFile
                .downloadFile({
                    filename: filename,
                    params: {id: this.statusManager.importfile.id},
                    servicename: 'getimportlogfile',
                })
                .catch((reason: string) => this.messageData(createErrorMessage(String(reason))))
        },
        validator: () => !!this.statusManager.importfile?.pathlogfile,
    }

    private btnAddNextSyncStep: TBtnHeader = {
        cls: 'btn-action',
        label: 'synccycle.step.btn.addnextsyncstep',
        icon: 'fa-arrow-down',
        onClick: () => {
            global.dialogManager.addConfirm({
                title: `synccycle.step.dialog.addnextsyncstep`,
                content: lm.t('synccycle.step.dialog.addnextsyncstep.body') ?? '',
                buttons: {
                    cancel: {
                        label: `synccycle.step.dialog.addnextsyncstep.btn.cancel`,
                    },
                    confirm: {
                        cls: 'btn-danger',
                        label: `synccycle.step.dialog.addnextsyncstep.btn.confirm`,
                        onClick: () => {
                            Promise.resolve()
                                .then(() => {
                                    this.statusManager.isSubmitting(true)
                                    this.messageData({message: PLEASE_WAIT_MESSAGE})
                                })
                                .then(() => this.statusManager.do_addsyncstep())
                                .then(() => this.statusManager.init())
                                .then(() => {
                                    this.crudMode('read')
                                    this.statusManager.isSubmitting(false)
                                    this.messageData(null)
                                    global.snackbarData({message: `synccycle.step.dialog.addnextsyncstep.message.success`})
                                })
                                .catch((reason: string) => {
                                    this.statusManager.isSubmitting(false)
                                    this.messageData(createErrorMessage(String(reason)))
                                })
                        },
                    }
                }
            })
        },
        validator: () => {
            const a = !this.isCrudMode('update')
            const b = !this.isAnySyncstepCreateOrUpdate()
            const c = this.statusManager.permission() >= Permission.OrganizationAdmin;
            return a && b && c
        },
        enabled: () => !!this.statusManager.getNextCompanySyncstep(),
    }

    private btnDeleteLastSyncStep: TBtnHeader = {
        label: 'synccycle.step.btn.deletelastsyncstep',
        cls: 'btn-destructive',
        icon: 'fa-trash-alt',
        onClick: () => {
            global.dialogManager.addConfirm({
                title: `synccycle.step.dialog.deletelastsyncstep`,
                content: lm.t('synccycle.step.dialog.deletelastsyncstep.body') ?? '',
                buttons: {
                    cancel: {
                        label: `synccycle.step.dialog.deletelastsyncstep.btn.cancel`,
                    },
                    confirm: {
                        cls: 'btn-danger',
                        label: `synccycle.step.dialog.deletelastsyncstep.btn.confirm`,
                        onClick: () => {
                            Promise.resolve()
                                .then(() => {
                                    this.statusManager.isSubmitting(true)
                                    this.messageData({message: UPDATING_MESSAGE})
                                })
                                .then(() => this.statusManager.do_deletelastsyncstep())
                                .then(() => this.statusManager.init())
                                .then(() => {
                                    this.crudMode('read')
                                    this.statusManager.isSubmitting(false)
                                    this.messageData(null)
                                    global.snackbarData({message: `synccycle.step.dialog.deletelastsyncstep.message.success`})
                                })
                                .catch((reason: string) => {
                                    this.statusManager.isSubmitting(false)
                                    this.messageData(createErrorMessage(String(reason)))
                                })
                        },
                    }
                }
            })
        },
        validator: () => {
            const a = !this.isCrudMode('update')
            const b = !this.isAnySyncstepCreateOrUpdate()
            const c = this.statusManager.permission() >= Permission.OrganizationAdmin;
            const d = !!this.statusManager.company.lastsyncstep?.syncstepname
            return a && b && c && d
        }
    }

    public isAnySyncstepCreateOrUpdate(mutableCompanySyncstep?: MutableCompanySyncStep): boolean {
        return this.mutableCompanySyncsteps().some((mcss: MutableCompanySyncStep) => {
            if (mcss == mutableCompanySyncstep) {
                return false
            }
            return mcss.isCrudMode('local', 'create', 'update');
        })
    }

    private getComboboxSyncstepsParams(): IComboboxV2Options<ISyncstep> {
        const listSource = createServiceListPromise<ISyncstep>({
            name: 'getsyncsteps',
            params: getSearchParamsFn('getsyncsteps'),
        })
        return {
            inputAttrs: {placeholder: lm.t('synccycle.create.hint')},
            input: this.syncstepPickerInput,
            selectionMode: 'pick',
            option: {
                label: o => nsSync.getSyncstepName(o),
                tooltip: o => lm.t(nsTooltip.getTitle_syncstep(o!)) ?? '',
                constrain: o => !this.mutableCompanySyncsteps().map((mcss: MutableCompanySyncStep) => mcss.companySyncstep.syncstep.id).includes(o.id),
            },
            promise: listSource.promise,
            onDispose: listSource.onDispose,
            onSelect: (o) => {
                if (o) {
                    this.addSyncstep(o)
                }
            },
        }
    }

    private addSyncstep(syncstep: ISyncstep) {
        const domain = _.last(this.mutableCompanySyncsteps())?.prop?.domain() ?? ''
        const index = (Math.max(...this.mutableCompanySyncsteps().map((o: MutableCompanySyncStep) => o.index())) ?? 0) + 1
        const css: ICompanySyncstep = {
            active: false,
            customerkey: '',
            description: '',
            domain: domain,
            eHubForm: [],
            filters: [],
            id: 0,
            importanchorsbeforesync: false,
            order: index + 1,
            passwordexport: false,
            passwordexportdomain: '',
            prescriptblock: '',
            ruleset: [],
            scriptblock: '',
            syncstep: syncstep,
            system: null as unknown as ISystem,
        }
        this._mutableCompanySyncsteps.push(new MutableCompanySyncStep(css, null, this, this.statusManager, index))
        this.updateIndexes()
    }

    public updateIndexes() {
        let index = 0
        const arr = this.mutableCompanySyncsteps();
        arr.forEach((mcss: MutableCompanySyncStep, i: number) => {
            switch (mcss.crudMode()) {
                case "create":
                case "read":
                case "update":
                    mcss.index(index)
                    index += 1
                    break;
                case "delete":
                    break;
            }
        })
    }

    public removeSyncstep(mutableCompanySyncstep: MutableCompanySyncStep) {
        this._mutableCompanySyncsteps.remove(mutableCompanySyncstep)
        this.updateIndexes()
    }

    private submit() {
        this.updateIndexes()

        const all: MutableCompanySyncStep[] = [
            ...this.getDeleted(),
            ...this.getCreated(),
            ...this.getUpdated(),
        ]

        // fixme remove this logic when API handles deletecompanysyncstep gracefully
        const shouldEmptyCache = !!this.getDeleted().length

        const doNext = (): Promise<any> => {
            const mcss = all.shift()
            if (!mcss) return Promise.resolve(null)
            return Promise.resolve()
                .then(() => mcss.submitAll())
                .then(() => doNext())
        }

        return Promise.resolve()
            .then(() => {
                this.statusManager.isSubmitting(true)
                this.messageData({message: PLEASE_WAIT_MESSAGE})
            })
            .then(() => doNext())
            .then(() => shouldEmptyCache ? this.statusManager.do_emptycache() : null)
            .then(() => {
                this.isReady(false)
                this.crudMode('read')
                this.statusManager.removeCache()
            })
            .then(() => this.statusManager.init())
            .then(() => {
                this.statusManager.isSubmitting(false)
                this.messageData(null)
                this.isReady(true)
                global.snackbarData({message: 'synccycle.message.success'})
                this.notifyAboutPauseDeltaSync()
            })
            .catch((reason: string) => {
                this.statusManager.isSubmitting(false)
                this.messageData(createErrorMessage(String(reason)))
            })
    }

    private getCreated(): MutableCompanySyncStep[] {
        return this.mutableCompanySyncsteps().filter((o: MutableCompanySyncStep) => o.crudMode() == 'create')
    }

    private getUpdated(): MutableCompanySyncStep[] {
        return this.mutableCompanySyncsteps().filter((o: MutableCompanySyncStep) => o.crudMode() == 'update' && o.isChanged())
    }

    private getDeleted(): MutableCompanySyncStep[] {
        return this.mutableCompanySyncsteps().filter((o: MutableCompanySyncStep) => o.crudMode() == 'delete')
    }

    private isAddToQueButtonsAvailable(): boolean {
        const isDeltaSync = this.statusManager.company.deltasync
        const isPauseDeltasyncFalse = !this.statusManager.mutableCompany.props.pausedeltasync!()
        const isSyncStatus_executed = ['executed', 'executedwitherrors'].includes(this.statusManager.getSyncCycleStatus())
        const isSyncableEdits = this.statusManager.mutableCompany.props.syncableedits!()
        const isForceFullSync = this.statusManager.mutableCompany.props.forcefullsync!()
        return isPauseDeltasyncFalse && isDeltaSync && isSyncStatus_executed && !isSyncableEdits && !isForceFullSync
    }

    private notifyAboutPauseDeltaSync() {
        const pausedeltasync = this.mutableCompany.props.pausedeltasync!();
        const notifyAboutPauseDeltaSync = this.statusManager.notifyAboutPauseDeltaSync();
        this.statusManager.notifyAboutPauseDeltaSync(false)
        if (pausedeltasync && notifyAboutPauseDeltaSync) {
            global.dialogManager.addConfirm({
                title: 'synccycle.dialog.deltasyncstillpaused',
                content: lm.t('synccycle.dialog.deltasyncstillpaused.body') ?? '',
                buttons: {
                    confirm: {
                        label: 'synccycle.dialog.deltasyncstillpaused.btn.confirm',
                        onClick: () => {
                            const newBool = false
                            this.messageData({message: UPDATING_MESSAGE})
                            this.statusManager.isSubmitting(true)
                            this.mutableCompany.props.pausedeltasync!(newBool)
                            Promise.resolve()
                                .then(() => this.mutableCompany.submit(['pausedeltasync'])
                                    .then((data) => {
                                        global.snackbarData({message: `synccycle.dialog.pausedeltasync.message.${newBool}`})
                                        this.messageData(null)
                                        this.init()
                                        this.statusManager.isSubmitting(false)
                                    })
                                )
                                .catch((reason: string) => {
                                    this.statusManager.removeCache('getcompany', 'getimporthrfile')
                                    return Promise.resolve()
                                        .then(() => this.statusManager.init())
                                        .then(() => this.messageData(createErrorMessage(String(reason))))
                                })
                        }
                    },
                    cancel: {
                        label: 'synccycle.dialog.deltasyncstillpaused.btn.cancel',
                    }
                },
            })
        }
    }

    public showCompanySyncstep(companySyncstepId: ICompanySyncstep['id']) {
        this.mutableCompanySyncsteps().find((o: MutableCompanySyncStep) => o.companySyncstep.id == companySyncstepId)?.isExpanded(true)
        nsDom
            .waitForElement('.row.syncstep[aria-expanded="true"]')
            .then(element => {
                setTimeout(() => element.scrollIntoView({behavior: 'smooth', block: 'center'}), 300)
            })
            .catch(() => {
                // fail silently
            })
    }

    dispose() {
        this.kosub.unsuscribeAll()
    }

}
